"use strict";

import { addTimesToResponse } from "../../utils/videoTimes";

export default class TourCtrl {
  static get UID() {
    return "tourCtrl";
  }

  constructor(updateFac, modelFac, siteConst, $filter) {
    "ngInject";
    Object.assign(this, { updateFac, modelFac, siteConst, $filter });

    this.comingSoonVideos = this.newestVideos = {};

    this.newestFilter = "latest";
    this.modelCount = this.siteConst.tour.models || 25;

    this.updatesCount = this.siteConst.tour.updates || 12;
    this.comingCount = this.siteConst.tour.comingSoon || 3;

    this.updateFac.getFutureUpdates(this.comingCount).then(response => {
      this.comingSoonVideos = addTimesToResponse(response, this.$filter);
    });

    this.videoFilter(this.newestFilter);

    this.modelFac.getModels().then(response => {
      if (response.data.result === "success") {
        this.models = response.data.data;
      }
    });
  }

  videoFilter(filter) {
    if (
      filter === this.newestFilter &&
      Object.keys(this.newestVideos).length > 0
    ) {
      return;
    }

    this.newestFilter = filter;

    this.updateFac.getUpdates(this.updatesCount, filter).then(response => {
      this.newestVideos = addTimesToResponse(response, this.$filter);
    });
  }
}



// WEBPACK FOOTER //
// ./~/site_core/src/features/tour/tourCtrl.js